module.exports = __webpack_public_path__ + "static/media/ic_chevron_up.ef1f7522.svg";